//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Documentalidade() { 
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Documentalidade
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação do critério:
            </h4>
            <br></br>
            <p align="justify"> <strong> Critério que identifica o grau em que um módulo está documentado em relação aos comentários no código-fonte e às regras de negócios 
              que ele atende. Além disso, esse critério verifica o grau em que as relações entre os módulos e as funções estão documentados, principalmente em relação aos 
              dados de entrada inseridos para o módulo funcionar e as saídas geradas. </strong> </p>
              <p align="justify"> <strong> Qual é o seu peso na avaliação desse critério? Digite no campo abaixo </strong> </p>
            <Form.Control
                    placeholder=""
                    style={{  }}
                    value={answers['inicial'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'inicial')
                    }}
                    required
                    
                  />
            <br></br>

            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Avaliação dos critérios:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              <strong>Responsabilidade única</strong>:  Padrão de documentação: A equipe de desenvolvimento do software científico deve seguir um padrão único na documentação 
              que siga o princípio da simplicidade, como definir o inglês como idioma oficial da documentação. A ideia é a de que todos os desenvolvedores do projeto possam 
              seguir a mesma lógica em todos os documentos gerados pelo projeto. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
                 <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao1"
                                checked={answers[1] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao1"
                                checked={answers[1] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao1"
                                checked={answers[1] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao1"
                                checked={answers[1] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[1] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Estruturar a documentação em níveis: O conceito por trás dessa sugestão é o de que a documentação do projeto seja feita do micro para o macro, ou seja, das menores 
              porções importantes para as maiores, e que a responsabilidade da documentação seja compartilhada por todos. Seguindo essa estrutura hierárquica, a documentação micro 
              sofrerá mais atualizações e estará em constante evolução, de acordo com o desenvolvimento e evolução de cada função, enquanto a documentação macro sofrerá menos atualizações. 
              Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao2"
                                checked={answers[2] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao2"
                                checked={answers[2] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao2"
                                checked={answers[2] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao2"
                                checked={answers[2] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[2] = 4;
                                  setAnswers(answers_)
                                }}
                              />

                
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Significância de comentários: A equipe de desenvolvimento deve fazer comentários realmente relevantes, que expliquem o porquê de o código-fonte fazer algo e não apenas 
              mostre o que ele faz. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao3"
                                checked={answers[3] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao3"
                                checked={answers[3] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao3"
                                checked={answers[3] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao3"
                                checked={answers[3] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[3] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Adicionar exemplos e tutorias: A documentação do software, principalmente as macro, devem apresentar exemplos e tutoriais que auxiliem o leitor da documentação a 
              entender de forma eficiente o que o módulo faz, a importância de suas funções e os resultados gerados. Como essa boa prática é atendida? <Attention />
              </Form.Label>
              <div>
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao4"
                                checked={answers[4] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao4"
                                checked={answers[4] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao4"
                                checked={answers[4] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao4"
                                checked={answers[4] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[4] = 4;
                                  setAnswers(answers_)
                                }}
                              />
                </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Simplificação de leitura: A equipe de desenvolvimento deve utilizar recursos que facilitem o entendimento do código-fonte do software. Por exemplo, deve-se utilizar 
              tabela quando o módulo ou função trabalhar com muitos parâmetros ou dados. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
                
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao5"
                                checked={answers[5] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao5"
                                checked={answers[5] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao5"
                                checked={answers[5] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao5"
                                checked={answers[5] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[5] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
              Especificar versão e autoria: Toda a documentação gerada deve apresentar a sua versão, data, autor e demais dados relevantes que auxilie na identificação 
              da versão da documentação. Como essa boa prática é atendida?  <Attention />
              </Form.Label>
              <div>
                
              <Form.Check
                                type="radio"
                                label="Atendimento total"
                                name="questao6"
                                checked={answers[6] === 1}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 1;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento parcial"
                                name="questao6"
                                checked={answers[6] === 2}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 2;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Atendimento inexistente"
                                name="questao6"
                                checked={answers[6] === 3}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 3;
                                  setAnswers(answers_)
                                }}
                              />
                              <Form.Check
                                type="radio"
                                label="Não sabe responder"
                                name="questao6"
                                checked={answers[6] === 4}
                                onChange={() => {
                                  let answers_={...answers}
                                  answers_[6] = 4;
                                  setAnswers(answers_)
                                }}
                              />
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
